import { type FormEvent, type ReactNode, useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { TelaAuth } from '../components/TelaAuth';
import { BlocoAviso, Botao, Campo } from '../components/ui';
import { useAuth } from '../lib/auth';
import { ApiError } from '../lib/http';
import { MSG_ERRO_REDE, MSG_SESSAO_EXPIRADA, mensagemDeErro } from '../lib/erros';
import { lerDestino, limparDestino } from '../lib/session';

export function LoginPagina(): ReactNode {
  const { usuario, carregando, entrar } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const expirada = params.get('expirada') === '1';

  if (!carregando && usuario) {
    const destino = params.get('destino') ?? lerDestino() ?? '/';
    limparDestino();
    return <Navigate to={destino} replace />;
  }

  const aoEnviar = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(identificador.trim(), senha);
      const destino = params.get('destino') ?? lerDestino() ?? '/';
      limparDestino();
      navigate(destino, { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        setErro(err.ehRede ? MSG_ERRO_REDE : mensagemDeErro(err.codigo));
      } else {
        setErro(MSG_ERRO_REDE);
      }
    } finally {
      setEnviando(false);
    }
  };

  return (
    <TelaAuth>
      <form onSubmit={(e) => void aoEnviar(e)} className="flex flex-col gap-4" noValidate>
        {expirada && <BlocoAviso tom="aviso">{MSG_SESSAO_EXPIRADA}</BlocoAviso>}
        {erro && <BlocoAviso tom="erro">{erro}</BlocoAviso>}
        <Campo
          rotulo="E-mail ou usuário"
          autoComplete="username"
          autoFocus
          value={identificador}
          onChange={(e) => setIdentificador(e.target.value)}
        />
        <Campo
          rotulo="Senha"
          type="password"
          autoComplete="current-password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        <Botao type="submit" carregando={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </Botao>
        <Link to="/recuperar" className="text-nota text-acento-texto underline">
          Esqueci minha senha
        </Link>
      </form>
    </TelaAuth>
  );
}
